import type { SxProps, Theme } from "@mui/material/styles";
import {
  HEADER_HEIGHT,
  SIDE_PADDING,
  SUBMENU_HEIGHT,
} from "../../theme/consts";
import { generalSectionSx } from "../Layout";

// Scroll container - determines scroll length for sticky/snap effect
// Uses svh (small viewport height) for stable sizing on mobile
// Negative margin creates overlap with previous section for smooth transition
export const scrollContainerSx: SxProps<Theme> = {
  height: "120svh",
  position: "relative",
  marginTop: "-8rem",
  // marginTop: { xs: "-10rem", "2xl": "-30svh" },
  zIndex: 1,
  scrollMarginTop: `-8rem`,
};

// Sticky container - stays in viewport during scroll (below fixed header)
// Uses svh for stable sizing that doesn't change with mobile address bar
// Background color ensures proper coverage when overlapping with previous section
export const stickyContainerSx: SxProps<Theme> = {
  position: "sticky",
  top: 0,
  height: "100svh",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",

  background: `linear-gradient(
    180deg,
    transparent 0%,
   #f8fafc 100px,
    #f8fafc 100%
  )`,
};

// Section content container
export const sectionContainerSx: SxProps<Theme> = {
  height: "100%",
  // maxHeight: {
  //   xs: `calc(100svh - ${HEADER_HEIGHT})`,
  //   md: `calc(100svh - ${HEADER_HEIGHT} - ${SUBMENU_HEIGHT})`,
  // },
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  boxSizing: "border-box",
  ...generalSectionSx,
  // padding: {
  //   xs: `1rem ${SIDE_PADDING.xs} 2rem`,
  //   md: `2rem ${SIDE_PADDING.md} 2rem`,
  //   xl: `2rem ${SIDE_PADDING.xl} 2rem`,
  // },
};

// Flywheel container - centered SVG
export const flywheelContainerSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
  padding: { xs: 0, md: "2rem" },
};
